export default {
  name: 'tab-focusable',

  data () {
    return {
      tabFocused: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/tab-focusable.js